// extracted by mini-css-extract-plugin
export default {"subContainer":"styles_subContainer__ZHvN4","mainContainerForm":"styles_mainContainerForm__hXIqn","txtIntro":"styles_txtIntro__hn+pK"};